<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-account-multiple-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add SCM Employee</span>
      <span v-else>Edit SCM Employee </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col class="py-2 mx-auto" cols="8">
            <form-group name="name" :attribute="`fields.name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2 mx-auto" cols="8">
            <form-group name="email" :attribute="`fields.email`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.email"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>

          <v-col cols="8" class="mx-auto">
            <section class="transparent-field mt-8">
              <v-switch
                v-model="form.is_active"
                inset
                :true-value="1"
                :false-value="0"
                label="Is Active ?"
                color="success"
              ></v-switch>
            </section>
          </v-col>

          <v-col cols="8" class="mx-auto">
            <v-btn
              class="success text-capitalize"
              large
              :loading="submitting"
              type="submit"
              width="100%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        is_active: 0,
      },
      isEdited: false,
      valueTypes: [{ name: "amount" }, { name: "percentage" }],
      majorsIndex: [],
      globalServerErrors: null,
      loadingData: false,
      start_date_modal: false,
      end_date_modal: false,
      submitting: false,
    };
  },
  created() {
    this.editCreateBoolean();
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createScmCamp();
      } else {
        this.editScmCamp();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `scm/employees`,
        id: id,
      })
        .then((res) => {
          const { employee } = res.data;
          this.form = employee;
        })
        .catch(() => {});
    },
    createScmCamp() {
      this.submitting = true;
      StoreData({
        reqName: `scm/employees`,
        data: this.form,
      })
        .then(() => {
          this.$router.push("/scm/employees");
          this.submitting = false;
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
          this.submitting = false;
        })
        .finally(() => {
          this.reset();
          this.submitting = false;
        });
    },
    editScmCamp() {
      this.submitting = true;

      const { name, email, is_active } = this.form;
      UpdateData({
        reqName: `scm/employees`,
        data: {
          name,
          email,
          is_active,
          _method: "put",
        },
        id: this.$route.params.id,
      })
        .then(() => {
          this.isEdited = false;
          this.submitting = false;

          this.$router.push("/scm/employees");
          this.reset();
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
          this.submitting = false;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    reset() {
      this.$v.form.$reset();
      this.form = {};
      this.$store.dispatch("ClearServerErrors");
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "scmEmployeesEdit") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(190),
      },
      email: {
        required,
        email,
      },
    },
  },
};
</script>
